import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import { IIndexTypeGroup } from "../../indexTypes/model/IndexTypeGroup";
import IndexTypeGroupMapper from "../../indexTypes/service/IndexTypeGroupMapper";
import IndexTypeGroupParamMapper from "../../indexTypes/service/IndexTypeGroupParamMapper";

export default class GetIndexTypeGroupTreeInteractor {
  private resource: GetAllResourceEntriesInteractor<IIndexTypeGroup>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(organisationId: number, categoryId: number) {
    return this.resource.execute(
      `organisations/${organisationId}/index-categories/${categoryId}/index-groups`,
      IndexTypeGroupMapper,
      IndexTypeGroupParamMapper
    );
  }
}
